"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionTableUpstreamDatabasesQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryGql_1 = require("../../queries/VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryGql");
var VirtualConnectionTableUpstreamDatabasesQueryGql_1 = require("../../queries/VirtualConnectionTableUpstreamDatabasesQueryGql");
var DatabaseRowDataFunctions_1 = require("../database/functions/DatabaseRowDataFunctions");
var DatabasesDisplayGrid_1 = require("../sharedDisplayGrid/DatabasesDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
        resultData.virtualConnectionTables[0].upstreamDatabasesConnection;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    var virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
    var virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
    var column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
    return column ? column.upstreamDatabasesConnection : null;
}
function selectMaxCountsResult(resultData) {
    return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
}
function selectMaxCountsResultForFilteredQuery(resultData) {
    var virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
    var virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
    var column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
    return column;
}
function getRowDataForDatabase(table, resultData) {
    return DatabaseRowDataFunctions_1.getRowDataWithMaxCountsForDatabase(table, selectMaxCountsResult(resultData));
}
function getRowDataForDatabaseForFilteredQuery(table, resultData) {
    return DatabaseRowDataFunctions_1.getRowDataWithMaxCountsForDatabase(table, selectMaxCountsResultForFilteredQuery(resultData));
}
function VirtualConnectionTableUpstreamDatabasesQueryGrid(props) {
    var publishedConnectionsLineageEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var emptyGridMessage = Localize_1.Messages.EmptyUpstreamDatabasesLineageGridMessage();
    var emptyFilteredGridMessage = Localize_1.Messages.EmptyUpstreamFilteredDatabasesLineageGridMessage();
    return props.filteredColumnId ? (
    // Query with Selected Database as Filter
    React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryGql_1.VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryGql, partialQueryVariables: {
            vizportalUrlId: props.vizportalUrlId,
            selectedColumnId: props.filteredColumnId,
            orderBy: props.orderBy,
            publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled
        }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: getRowDataForDatabaseForFilteredQuery }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(DatabasesDisplayGrid_1.DatabasesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    })) : (
    // Query without Selection
    React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: VirtualConnectionTableUpstreamDatabasesQueryGql_1.VirtualConnectionTableUpstreamDatabasesQueryGql, partialQueryVariables: {
            vizportalUrlId: props.vizportalUrlId,
            orderBy: props.orderBy,
            publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: getRowDataForDatabase }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(DatabasesDisplayGrid_1.DatabasesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
}
exports.VirtualConnectionTableUpstreamDatabasesQueryGrid = VirtualConnectionTableUpstreamDatabasesQueryGrid;
//# sourceMappingURL=VirtualConnectionTableUpstreamDatabasesQueryGrid.js.map